
<template>
  <component
    ref="chart"
    class='va-chart'
    :is="chartComponent"
    :chartOptions="chartOptions"
    :chart-data="data"
  />
</template>

<script>
import VaChart from 'vuestic-ui/src/components/vuestic-components/va-chart/VaChart'

export default {
  name: 'sp360-chart',
  mixins: [VaChart],
  computed: {
    chartOptions () {
      return Object.assign({}, this._preOptions, this.options)
    },
    _preOptions () {
      return { plugins: { datalabels: false } }
    },
  },

}
</script>

<style lang="scss">

.grafico-segmentado {
  .va-chart {
    max-height: 20rem;
  }
}

.grafico-alto {
  .va-chart {
    max-height: 50rem;
  }
}

.grafico-bar-chart-horizontal {
  .va-chart {
    max-height: 25rem;
  }
}

.grafico-bar-chart-vertical {
  .va-chart {
    max-height: 25rem;
  }
}

.grafico-complementar {
  .va-chart {
    max-height: 17rem;
  }
}

</style>
